











import { Vue, Component } from 'vue-property-decorator';
import * as config from './config';
import { autoOpenApp } from '@/common/ts/common';
import Banner from '@/components/Banner.vue';
import BottomTabbar from '@/components/BottomTabbar.vue';
import { getBaseinfo } from './api';
import { userHelper } from './api/index';

@Component({
  components: {
    Banner,
    BottomTabbar,
  },
})
export default class Home extends Vue {
  option = config.OPTHINES;
  banner = require('./assets/banner.jpg');
  baseInfo = {};
  async created() {
    const res = await getBaseinfo(this.option.voteName);
    this.$addPv(res.data.activityId);
    this.baseInfo = res.data;
    userHelper().then((res) => console.log('访问userHelper'));
    if (!window.udid) {
      autoOpenApp();
      return;
    }
  }
}
